(async function () {

  const cache = {};
  let running = false;

  async function getProductDiscount(handle) {

    if (cache[handle]) return cache[handle];

    try {
      const res = await fetch(`/products/${handle}?view=ac_product_tiers`);
      if (!res.ok) return null;

      const html = await res.text();
      cache[handle] = html;

      return html;

    } catch (e) {
      console.error("Tier fetch error:", handle);
      return null;
    }
  }

  async function renderBadges() {

    if (running) return;
    running = true;

    /* ---------------- COLLECTION PAGE ---------------- */

    const collectionProducts = document.querySelectorAll(
      ".product-grid-item[data-product-grid-item]"
    );

    for (const product of collectionProducts) {

      if (product.dataset.tierBadge === "true") continue;

      const link = product.querySelector('a[href*="/products/"]');
      if (!link) continue;

      const handle = link.href.split("/products/")[1]?.split("?")[0];
      if (!handle) continue;

      const html = await getProductDiscount(handle);
      if (!html) continue;

      product.style.position = "relative";

      const badge = document.createElement("div");
      badge.className = "tier-badge";
      badge.innerHTML = html;

      product.appendChild(badge);

      product.dataset.tierBadge = "true";
    }

    /* ---------------- QUICK VIEW MODAL ---------------- */

    const quickProducts = document.querySelectorAll(
      '.quick-shop-modal product-component[data-product-handle]'
    );

    for (const product of quickProducts) {

      if (product.dataset.tierBadge === "true") continue;

      const handle = product.dataset.productHandle;
      if (!handle) continue;

      const html = await getProductDiscount(handle);
      if (!html) continue;

      const imageArea = product.querySelector(".product__main-photos");
      if (!imageArea) continue;

      imageArea.style.position = "relative";

      const badge = document.createElement("div");
      badge.className = "tier-badge";
      badge.innerHTML = html;

      imageArea.appendChild(badge);

      product.dataset.tierBadge = "true";
    }

    /* ---------------- PRODUCT PAGE ---------------- */

    const productPages = document.querySelectorAll(
      'product-component[data-product-handle][data-modal="false"]'
    );

    for (const product of productPages) {

      if (product.dataset.tierBadge === "true") continue;

      const handle = product.dataset.productHandle;
      if (!handle) continue;

      const html = await getProductDiscount(handle);
      if (!html) continue;

      const imageArea = product.querySelector(".product__main-photos");
      if (!imageArea) continue;

      imageArea.style.position = "relative";

      const badge = document.createElement("div");
      badge.className = "tier-badge";
      badge.innerHTML = html;

      imageArea.appendChild(badge);

      product.dataset.tierBadge = "true";
    }

    running = false;
  }

  /* -------- INITIAL RUN -------- */

  renderBadges();

  window.addEventListener("load", renderBadges);

  /* -------- OBSERVE AJAX / QUICK VIEW -------- */

  const observer = new MutationObserver(() => {
    renderBadges();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();